export const editorConfigMobile = {
    Photobook: ['app'],
    PaddedPhotoBook: ['online'],
    CutoutPhotoBook: ['online'],
    MomentsPhotoBook: ['online'],
    Prints: ['app', 'online'],
    Canvas: ['app', 'online'],
    Plexiglas: ['app', 'online'],
    Poster: ['app', 'online'],
    Forex: ['app', 'online'],
    Aluminium: ['app', 'online'],
    Mug: ['app', 'online'],
    LoveMug: ['online'],
    MagicMug: ['online'],
    Jigsaw: ['online'],
    Magnet: ['online'],
    Cushion: ['online'],
    Card: ['online'],
    Calendar: ['online'],
    StudentPlakat: ['online'],
};

// Remove this once Everest app supports books CMS-16820
export const editorConfigMobileBeta = {
    Photobook: ['online'],
    PaddedPhotoBook: ['online'],
    CutoutPhotoBook: ['online'],
    MomentsPhotoBook: ['online'],
    Prints: ['app', 'online'],
    Canvas: ['app', 'online'],
    Plexiglas: ['app', 'online'],
    Poster: ['app', 'online'],
    Forex: ['app', 'online'],
    Aluminium: ['app', 'online'],
    Mug: ['app', 'online'],
    LoveMug: ['online'],
    MagicMug: ['online'],
    Jigsaw: ['online'],
    Magnet: ['online'],
    Cushion: ['online'],
    Card: ['online'],
    Calendar: ['online'],
    StudentPlakat: ['online'],
};
